var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCateory1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00001 61.9666C3.33334 61.9666 2 60.6212 2 58.9396V36.3051C2 34.6235 3.33334 33.2782 5.00001 33.2782C6.66667 33.2782 8.00001 34.6235 8.00001 36.3051V58.9396C8.00001 60.6212 6.63334 61.9666 5.00001 61.9666Z",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9999 61.9664C57.3333 61.9664 55.9999 60.6211 55.9999 58.9394V43.704C55.9999 42.0224 57.3333 40.6771 58.9999 40.6771C60.6666 40.6771 62 42.0224 62 43.704V58.9394C62 60.6211 60.6666 61.9664 58.9999 61.9664Z",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56 52.0785H8V62H56V52.0785Z",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9001 52.0786H11.4335C9.53347 52.0786 7.9668 50.4978 7.9668 48.5808C7.9668 46.6638 9.53347 45.083 11.4335 45.083H22.9001C24.8001 45.083 26.3668 46.6638 26.3668 48.5808C26.3668 50.4978 24.8335 52.0786 22.9001 52.0786Z",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5668 2H45.9335V9.09647",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1 20.6998C43.6667 20.6998 41.7 18.7155 41.7 16.2604V13.5361C41.7 11.0809 43.6667 9.09668 46.1 9.09668C48.5333 9.09668 50.5 11.0809 50.5 13.5361V16.2604C50.5 18.7155 48.5333 20.6998 46.1 20.6998Z",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2668 2V24.6683",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8 37.5494C30.2667 37.5494 27.4333 34.657 27.4333 31.1256C27.4333 27.5605 30.3 24.7018 33.8 24.7018C37.3334 24.7018 40.1667 27.5942 40.1667 31.1256C40.1667 34.657 37.3334 37.5494 33.8 37.5494Z",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2668 37.5493V46.3273",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7001 29.1077H35.5334",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9668 33.2782H33.5335",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCateory1);
export default __webpack_public_path__ + "static/media/cateory1.3f9490eb879cc6f83f177e6d68021969.svg";
export { ForwardRef as ReactComponent };